<template>
  <div class="cmsc-tooltip">
    <div
      class="cmsc-tooltip-base"
      @mouseover="disabled = false"
      @mouseout="disabled = true"
    >
      <slot></slot>
    </div>
    <transition name="fade">
      <div v-show="!disabled" class="cmsc-tooltip-content">
        {{ content }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'cmscTooltip',
  props: ['content', 'disabled']
}
</script>

<style lang="stylus">
.cmsc-tooltip
  position relative

  .cmsc-tooltip-content
    position absolute
    top 50%
    left 65px
    white-space nowrap
    transform translateY(-50%)
    padding 0 5px
    height 26px
    line-height 28px
    font-size 12px
    color #515a6e
    background #eaf3fe
    border-radius 4px
    user-select none
</style>

